import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_Point } from "../../../../../student/student-pbis/shared/data.service";
import { GroupPointsInsertRequest } from "../../../../../student/student-pbis/shared/GroupPointsInsertRequest";

@Component({
	selector: "app-sgadd-pbis",
	templateUrl: "./sgadd-pbis.component.html",
	styleUrls: ["./sgadd-pbis.component.css"],
})
export class SGAddPBISComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_Student_Point,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		this.GroupID = this.SelectedGroup.GroupID;
		this.GroupName = this.SelectedGroup.GroupName;

		this.loadPointItem();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	user: any;

	PointsTransactionTypeID: any = 1;
	lstPointsTransactionType: any = [
		{
			ID: 1,
			Desc: "Earn Point",
		},
		{
			ID: 2,
			Desc: "Redeem Point",
		},
	];

	SelectedGroup: any;
	GroupID: any;
	GroupName: any;

	SchoolID: any;
	SchoolName: any;

	SelectedPoint: any;
	lstPoints: any = [];

	ItemLoading: any = true;
	Processing: any = false;

	AddStudentPrompt: boolean = false;

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////
	loadPointItem() {
		this.ItemLoading = true;

		var result = this.PBISService.PBISPointItemSelectList(this.PointsTransactionTypeID, this.SchoolID); //1 for Behavior?
		result.subscribe(
			(response) => {
				this.lstPoints = response;

				this.SelectedPoint = this.lstPoints[0];

				this.ItemLoading = false;
			},
			(error) => {
				this.ItemLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////
	onAdd() {
		if (this.lstPoints.length == 0) {
			return;
		}

		this.confirmationService.confirm({
			key: "addgroupwarning",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: 'NOTE: this will add a point to all of the students assigned to "' + this.GroupName + '". Do you want to continue?',
			header: "Confirm Add Points",
			icon: "fa",
			accept: () => {
				this.FinishAdd();
			},
		});
	}

	FinishAdd() {
		this.Processing = true;

		//
		// Create Request
		//

		let parms: GroupPointsInsertRequest = {
			GroupID: this.GroupID,
			PointsTransactionTypeID: 1, // 1 = Earned Point
			PointsItemID: this.SelectedPoint.PointsItemID,
			PointsItemValue: this.SelectedPoint.PointsItemValue,
			IsVoid: 0,
			c_PersonID: this.user.personID,
			AddStudentPrompt: this.AddStudentPrompt == true ? 0 : 1,
		};

		//
		// Call SP
		//

		var result = this.PBISService.GroupPointsInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Point was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the point: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////

	onPointsTransactionTypeIDChange(val) {
		this.PointsTransactionTypeID = val;

		this.loadPointItem();
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.ItemLoading || this.Processing;
	}

	//////////////////////////////////////////////////////////////////
}
